<template>
  <div
    class="modal fade"
    id="criteriaModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="criteriaModalLabel"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span
              aria-hidden="true"
            >&times;</span>
          </button>
          <h4
            class="modal-title"
            id="criteriaModalLabel"
          >
            {{ $t('label.criteria') }}
          </h4>
        </div>
        <div
          class="modal-body"
          v-if="selectedCriteria"
        >
          <div
            class="form-group"
            :class="{'has-error' : validations.name_en}"
          >
            <label class="required">{{ $t('label.englishName') }}</label>
            <input
              type="text"
              v-model="selectedCriteria.name_en"
              class="form-control"
              :placeholder="$t('label.englishName')"
            >
            <span
              class="label-error"
              v-if="validations.name_en"
            >
              {{ validations['name_en'][0] }}
            </span>
          </div>
          <div
            class="form-group"
            :class="{'has-error' : validations.name_km}"
          >
            <label class="required">{{ $t('label.khmerName') }}</label>
            <input
              type="text"
              v-model="selectedCriteria.name_km"
              class="form-control"
              :placeholder="$t('label.khmerName')"
            >
            <span
              class="label-error"
              v-if="validations.name_km"
            >
              {{ validations['name_km'][0] }}
            </span>
          </div>
          <div class="form-group">
            <label>
              <input
                type="checkbox"
                value="true"
                v-model="selectedCriteria.active"
              > {{ $t('label.active') }}
            </label>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-default"
            ref="closeModal"
            data-dismiss="modal"
          >
            {{ $t('button.close') }}
          </button>
          <button
            type="button"
            @click="store"
            :disabled="isSubmitting"
            class="btn btn-primary"
          >
            <i :class="`fa fa-${isSubmitting ? 'spinner fa-pulse fa-fw' : 'check-circle'}}`" />
            {{ isSubmitting ? $t('button.processing') : $t('button.save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'CriteriaModal',
  data () {
    return {
      isSubmitting: false,
      validations: {},
      selectedCriteria: {
        name_en: null,
        name_km: null,
        default_score: 0,
        active: null,
        criteria_id: null
      }
    }
  },
  computed: {
    ...mapFields('profileScoring', {
      _selectedCriteria: 'selectedCriteria'
    })
  },
  watch: {
    _selectedCriteria () {
      if (this._selectedCriteria) {
        const {
          name_en,
          name_km,
          default_score,
          active,
          id
        } = this._selectedCriteria

        this.selectedCriteria.name_en = name_en
        this.selectedCriteria.name_km = name_km
        this.selectedCriteria.default_score = default_score
        this.selectedCriteria.active = active
        this.selectedCriteria.criteria_id = id
      }
    }
  },
  methods: {
    resetState () {
      this.validations = {}
    },
    store () {
      this.validations = {}
      this.isSubmitting = true
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/profile-scoring/update-criteria', this.selectedCriteria)
        .then(({ data }) => {
          if (data.data) {
            this.$emit('refreshTable')
            this.$refs.closeModal.click()
          }
        })
        .catch((error) => {
          if (error.response && error.response.status && error.response.status === 422) {
            this.validations = error.response.data.errors
          } else {
            this.onResponseError(error)
          }
        })
        .finally(() => {
          this.isSubmitting = false
        })
    }
  }
}
</script>

<style scoped>

</style>
